export const unselect = Symbol('unselect');
//# sourceMappingURL=unselect.js.map